<template>
    <div class="container">
        
        <div class="newdata">
          <h1>Restframework+Vue-chartjs<br>データ入力でグラフ描画</h1>
          <p>データ: (3つの数字を半角で,で区切って入力し更新をクリック！ 例10,20,30)</p>
          <input v-model="new_data1">
          <div class="rdata">受信データ : {{res_data.vuedata}}</div>
        </div>
          <button v-on:click="New_Data">サーバーに送らないで更新</button>
          <button class = "btn2" v-on:click="Put_New_Data">サーバーに送って更新</button>
          <div class="small">
            <!-- <Bar :chart-data="chartData" :chart-options="chartOptions" /> -->
            <!-- Chart.js v4 -->
            <Bar id="my-chart-id" :options="chartOptions" :data="chartData" />
          </div>
    </div>
    </template>
    
    <script>
    // DataPage.vue
    import { Bar } from 'vue-chartjs'
    import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
    import axios from 'axios'
    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
    
    export default {
      name: 'BarChart',
      components: { Bar },
       data() {
        return {
            new_data1:[],
            res_data:null,
          chartData1: {
            labels: [ 'January', 'February', 'March'],
            datasets: [
              {
                label: 'Data One',
                backgroundColor: '#f87979',
                data: [40, 20, 12]
              }
            ]
          }
        }
      },
      created() {
            axios.defaults.xsrfCookieName = 'csrftoken' ;
            axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
             this.getData();
        },
      computed: {
          chartData() { return this.chartData1 },
          //chartOptions() { return /* mutable chart options */ }
        },
        methods: {
            New_Data(){
                this.chartData1={
                labels: [ 'January', 'February', 'March'],
                    datasets: [
                      {
                        label: 'Data One',
                        backgroundColor: '#f87979',
                        data: this.new_data1.split(',')
                        //data: this.res_data.vuedata.split(',')
                      }
                    ]
              }
            },
            Get_New_Data(){
                this.chartData1={
                labels: [ 'January', 'February', 'March'],
                    datasets: [
                      {
                        label: 'Data One',
                        backgroundColor: '#f87979',
                        //data: this.new_data1.split(',')
                        data: this.res_data.vuedata.split(',')
                      }
                    ]
              }
            },
            Put_New_Data(){
                axios.put('https://vchartren2.onrender.com/api/app_vchart2/1/?format=json',{ vuedata: this.new_data1 })
                    .then(response => {
                        this.res_data=response.data,
                        this.Get_New_Data()
                      })
                  .catch((err) => {
                   console.log(err);
                  })
            },
            getData() {
                axios.get('https://vchartren.onrender.com/api/app_vchart2/1/?format=json')
                    .then(response => {
                        this.res_data=response.data,
                        this.Get_New_Data()
                      })
                  .catch((err) => {
                   console.log(err);
              })
             }
        }
    }
    </script>
    <style scoped>
    .container{
        text-align:center;
    }
    .small{
    max-width: 300px;
    margin: 0 auto
    }
    .newdata{
    max-width: 400px;
    width: 80%;
    margin: 0 auto;
    padding: 5px 0;
    margin-bottom: 10px;
    background-color: #f5f5f5
    }
    .btn2 {
    background-color: orange
}
    .rdata{
        margin:20px;
        color: red;
    }
    input{
        padding:5px 10px;
    }
    button{
        max-width: 180px;
        width: 80%;
        background-color: teal;
        color: #000;
        font-weight: 700;
        padding: 20px 0;
        margin: 0 10px;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        margin-bottom: 50px
    }
    
    </style>